import {cloneDeep} from 'lodash';
import * as React from 'react';

import {IDocument, ITagline, IUserData} from '../../../../infrastructure/interfaces';
import {taglinesForDocument} from '../../../../infrastructure/Taglines';
import TaglineEditorForm from '../../../DocumentEditor/TaglineEditorForm';
import SettingsNav from './SettingsNav';

export interface ITaglineEditorProps {
  document: IDocument;
  taglines: ITagline[];
  userData: IUserData;
  saveDocument(document: IDocument, userID: string, redirect?: string): void;
  updateModelDocument(document: IDocument): void;
  cancelDocument(): void;
}

export interface ITaglineEditorState {
  document: IDocument;
}


export default class TaglineEditor extends React.Component<ITaglineEditorProps, ITaglineEditorState> {
  contentNode: Element;
  constructor(props: ITaglineEditorProps) {
	super(props);
	this.state = {
	  document: cloneDeep(props.document),
	};
  }

  componentWillUnmount() {
	if (this.props.updateModelDocument) {
	  this.contentNode.parentElement!.scrollTop = 0;
	  this.props.updateModelDocument(this.state.document);
	}
  }

  componentWillReceiveProps(nextProps: ITaglineEditorProps) {
	if (nextProps.document !== this.props.document) {
	  this.setState({ document: cloneDeep(nextProps.document) });
	}
  }

  onTaglineChange = (taglineTitle: string) => {
	this.setState({
	  document: {
		...this.state.document,
		title: taglineTitle,
	  },
	});
  }

  cancel = () => {
	this.setState({ document: cloneDeep(this.props.document) });
	if (this.props.cancelDocument) {
	  this.props.cancelDocument();
	}
  }

  onSave = () => {
	this.props.saveDocument(this.state.document, this.props.userData.id);
  }

  render() {
	const taglines = taglinesForDocument(this.props.taglines, this.state.document);
	return (
	  <div className="cropsEditorContainer" ref={(node) => { this.contentNode = node!; }}>
		<SettingsNav
		  cancel={this.cancel}
		  document={this.state.document}
		  onSave={this.onSave}
		/>
		<div className="">
		  <div className="cropsContainerTitle">
			Select cover tagline:
		</div>
		</div>
		<TaglineEditorForm
		  document={this.state.document}
		  taglines={taglines}
		  onTaglineChange={this.onTaglineChange}
		  className="settingsCropsListContainer"
		/>
	  </div>
	);
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/TaglineEditor.tsx